module.exports = __webpack_public_path__ + "img/bg_home4.1db0982a.png";